import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plank" }
const _hoisted_2 = { class: "plank__wrapper" }
const _hoisted_3 = { class: "plank__center" }
const _hoisted_4 = { class: "plank__title" }
const _hoisted_5 = { class: "plank__subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "plank__left-wrapper" }, [
        _createElementVNode("div", { class: "plank__left" }, [
          _createElementVNode("svg", {
            width: "14",
            height: "16",
            viewBox: "0 0 14 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M12.9231 6.07527C14.359 6.93071 14.359 9.0693 12.9231 9.92473L3.23077 15.6989C1.79487 16.5544 -7.24748e-08 15.4851 0 13.7742L4.89207e-07 2.2258C5.61682e-07 0.514929 1.79487 -0.554363 3.23077 0.301073L12.9231 6.07527ZM11.8462 8L2.15385 2.2258L2.15385 13.7742L11.8462 8Z",
              fill: "white"
            })
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString($props.title), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString($props.subtitle), 1)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "plank__right" }, [
        _createElementVNode("svg", {
          width: "6",
          height: "12",
          viewBox: "0 0 6 12",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M1.15809 1.53701C0.861443 1.07116 0.998606 0.453029 1.46446 0.156378C1.93031 -0.140274 2.54844 -0.00311095 2.84509 0.46274L5.68702 4.9256C6.10436 5.58098 6.10436 6.41876 5.68702 7.07414L2.84509 11.537C2.54844 12.0029 1.93031 12.14 1.46446 11.8434C0.998606 11.5467 0.861443 10.9286 1.15809 10.4627L3.65798 6.53701C3.86638 6.20938 3.86656 5.79029 3.65798 5.46274L1.15809 1.53701Z",
            fill: "#80858E"
          })
        ])
      ], -1))
    ])
  ]))
}